// frontend/src/components/ServicesSection.js
import React from 'react';

const services = [
    {
        title: 'Промышленная автоматизация',
        description: 'Разработка и внедрение АСУ ТП, телеметрия, поставка оборудования. Собственные разработки: УСПД «Фасконт», комплексы управления «БРИЗ», установки контактной точечной сварки.',
    },
    {
        title: 'Автоматизация бизнес-процессов',
        description: (
            <>
                Внедрение и сопровождение ПО на платформе «1С», разработка информационных порталов и специализированного программного обеспечения.{' '}
                <a
                    href="https://1c.ru"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#ffd014', textDecoration: 'underline' }}
                >
                    Официальный сайт 1С
                </a>
            </>
        ),
    },
    {
        title: 'IT-инфраструктура и инженерные системы',
        description: 'Проектирование ЛВС, ЦОД, систем связи, видеонаблюдения. Монтаж систем электроснабжения, вентиляции, кондиционирования, СКУД, АПС, ОПС, ИБП.',
    },
];

function ServicesSection() {
    return (
        <div id="services-section" className="t396" style={{ backgroundColor: '#ffffff' }}>
            <div className="t396__artboard" style={{ padding: '140px 0' }}>
                <div className="t-container">
                    <div className="t-row">
                        <div className="t-col t-col_12 t-align_center">
                            <h2 className="t-title t-title_md" style={{ marginBottom: '30px' }}>Наши услуги</h2>
                            <div className="t-descr t-descr_lg" style={{ maxWidth: '560px', margin: '0 auto 80px' }}>
                                Комплексные решения для автоматизации и инженерии
                            </div>
                        </div>
                    </div>
                    <div className="t-row">
                        {services.map((service, index) => (
                            <div key={index} className="t-col t-col_4">
                                <div className="t-card" style={{ backgroundColor: '#f6f9ff', borderRadius: '15px', padding: '32px', marginBottom: '20px', height: '100%' }}>
                                    <h3 className="t-card__title" style={{ fontSize: '20px', marginBottom: '10px' }}>{service.title}</h3>
                                    <div className="t-card__descr" style={{ fontSize: '15px', lineHeight: '1.55', color: '#4d3636' }}>
                                        {service.description}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ServicesSection;